import { Http } from '@app/base';
import { Problem, ProblemReport } from '@app/ui';
import { PropsWithChildren, useCallback } from 'react';
import { Layout } from './widgets';
import { store } from './store';
import { usersApi } from '@app/main/api';

function useSubmit() {
  return useCallback((report: ProblemReport) => Http.post('/api/problem-report', report), []);
}

function useUserInfo() {
  return useCallback(() => {
    const context = usersApi.endpoints.getContext.select()(store.getState()).data;
    if (context == null) throw new Error('User context is not loaded');

    return {
      id: context.id,
      organizationId: context.organizationId,
      locale: context.locale,
      roles: context.roles,
    };
  }, []);
}

export function AppProblemProvider(props: PropsWithChildren) {
  const { children } = props;
  const onSubmit = useSubmit();
  const userInfo = useUserInfo();

  return (
    <Problem.Provider onSubmit={onSubmit} screenshotRef={Layout.ref} userInfo={userInfo}>
      {children}
    </Problem.Provider>
  );
}
